import React from "react";

export const indexText = {
  dk: (
    <div style={{ color: "#fff", textAlign: "left" }}>
      <b>Hvad så nu?</b>
      <p>
        Du har nu udfyldt en selv-evaluering. Selve evalueringen bygger på de 71
        spørgsmål du netop har besvaret. Disse er fordelt på 12 parametre der
        hver dækker 5-6 spørgsmål. De 12 parametre beskriver kvaliteter og
        egenskaber som er vigtige i rollen som leder - både i ledelse af andre
        og i konteksten af at selvledelse.
      </p>

      <p />

      <b>Hvad er en selv-evaluering egentlig?</b>
      <p>
        En selv-evaluering indebærer, at man selv vurderer i hvilken grad man er
        enig i et udsagn, der beskriver en adfærd eller et personligt
        karakteristika; fx hvor godt passer udsagnet "Giver ikke umiddelbart op
        når tingene ikke 'bare' glider på dig". Skalaen der anvendes går fra 1
        til 6, hvor 1 = Meget ukarakteristisk og 6 = Meget karakteristisk.
      </p>
      <p />

      <b>Hvad kan jeg bruge min selv-evaluering til?</b>
      <p>
        Disse parametre fortæller noget om hvordan du opfatter sig selv, når du
        interagerer med andre - medarbejdere, kollegaer og ledere - samt hvilke
        relationer du derigennem skaber.
      </p>
      <p />

      <b>Hvordan får jeg mest muligt ud af min selv-evaluering?</b>
      <p>
        Det vigtige i forbindelse med en selv-evaluering er, at være så objektiv
        ærlig som muligt. Det betyder at man ikke skal være særlig kritisk eller
        særlig positiv. En nedvurdering eller overvurdering af en selv giver
        ikke et særligt brugbart resultat. Man skal ikke angive en ønskværdig
        afspejling af sig selv i rollen som leder, men derimod hvorledes man
        rent faktisk oplever sig selv interagere med andre. Ligesom man heller
        ikke skal have urealistiske høje krav til sig selv, med risiko for at
        man således bedømmer sig selv ekstra hårdt.
      </p>
      <p />

      <b>Hvad er værdien?</b>
      <p>
        Resultatet når du evaluerer dig selv på disse parametre, er 1) først og
        fremmest et dybere kendskab til hvilke parametre, der er vigtige i
        samspillet med andre. Det skaber en indre opmærksomhed, der kan anvendes
        i dit virke som leder og 2) som giver indikationer af områder, du måske
        ønsker at tildele mere opmærksomhed. Sidst men ikke mindst kan det 3)
        anvendes som et dialogværktøj i forbindelse med udvikling.
      </p>
      <p />

      <b>Hvad kan jeg bruge en 360 graders evaluering til?</b>
      <p>
        En 360 graders evaluering betyder kort fortalt at evalueringen går hele
        vejen rundt d.v.s. at såvel underordnede, overordnede samt ligestillede
        fx kollegaer kan evaluere dig efter samme parametre som du selv. Det vil
        sige, dem du inviterer, besvarer de samme 71 spørgsmål, men med
        udgangspunkt i hvordan de oplever dig. Således kan du se forskellen på
        hvordan de oplever dig i forhold til hvordan du ser dig selv.
      </p>

      <b>Hvad fortæller deres evaluering så om mig?</b>
      <p>
        Den fortæller egentlig ikke noget om dig, men mere noget om hvordan
        andre ser dig eller oplever dig i jeres gensidige arbejdsrelation. Du
        går måske rundt med et billede af dig selv, og måske har andre en anden
        oplevelse. Det er de opfattelser vi har af hinanden og de forskelle vi
        får øje på, der kan være skyld i misforståelser.
      </p>
      <p />

      <b>Anvendelighed</b>
      <p>
        En ting er, at få øje på hvor der kan være nogle forskelle i opfattelse.
        Noget andet er, at finde lidt mere præcist ud af hvad de forskelle går
        ud på - og endelig hvad de betyder. Derfor kan du bruge resultatet af
        evalueringen som et godt og bredt dialogværktøj i forbindelse med
        udviklingen af dit eget lederskab.
      </p>
    </div>
  ),
  en: (
    <div style={{ color: "#fff", textAlign: "left" }}>
      <b>Now what?</b>
      <p>
        You have now completed a self-assessment. The assessment is based on the
        71 questions you have just answered. These are divided into 12
        parameters with 5 or 6 questions under each. The parameters describe
        qualities and attributes that are important in the role as leader - both
        in leading others and in the context of leading self.
      </p>
      <p />
      <b>What is a self-assessment really?</b>
      <p>
        A self-assessment is where you assess the extent to which you agree with
        a statement that describes behavior or a personal characteristic; i.e.
        how well does the statement 'Does not give up immediately when things
        don't 'just go your way' describe you? The scale used ranges from 1 to
        6, where 1 = Very ucharacteristic and 6 = Very characteristic.
      </p>
      <p />
      <b>What can I use my self-assessment for?</b>
      <p>
        The parameters indicate how you perceive yourself when interacting with
        others - employees, coworkers and executives - and the quality of the
        relationships you build while doing so.
      </p>
      <p />
      <b>How do I get the most out of my self-assessment? </b>
      <p>
        The important thing about self-assessment is to be as objective as
        humanly possible. So don't be too critical nor too positive about
        yourself. An overvaluation or depreciation doesn't give you a
        particularly useful result. So don't depict a desirable
        I-should-be-reflection of yourself as a leader, but rather how you
        actually experience yourself interacting with others. Just as you
        shouldn't make unrealistically high demands of yourself at the risk of
        self-depreciation.
      </p>
      <p />
      <b>What is the value?</b>
      <p>
        The result when you assess yourself on these parameters is 1) first and
        foremost, a deeper knowledge of the parameters that are important in
        interacting with others. It generates awareness that you can use as a
        leader and 2) bring attention to areas you may want to develop further.
        Last but not least, it can 3) be used as a tool for dialogue in personal
        development.
      </p>
      <p />
      <b>What can I use a 360 degree assessment for?</b>
      <p>
        In short a 360 degree assessment means that both subordinates, peers and
        managers assess you on the 12 parameters. So those you invite to assess
        you, answer the same 71 questions, but based on how they experience you.
        So now you can compare your perception of self with how others perceive
        you.
      </p>
      <b>What does their evaluation tell me?</b>
      <p>
        It really does not tell you anything profound nor does it represent a
        truth. It provides you with the insight of how others 'see' you or
        experience you in your mutual working relationship. You have one picture
        of yourself, and someone else might have a totally difference
        experience. These perceptions we have of each other and the differences
        we notice about each other are the very things that can lead to
        misunderstandings and influence our relationship with each other.
      </p>
      <p />
      <b>Usability</b>
      <p>
        One thing is to spot where there might be differences in perception.
        Another thing is to find out precisely what those differences are about
        - and finally what they mean. Therefore, you can use the assessment as
        an extremely useful tool for dialogue in developing your own leadership.
      </p>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/Results/indexText.js